export default function isNumber(u: unknown): u is number {
  return typeof u === 'number' || (typeof u === 'string' && !isNaN(parseFloat(u)));
}
